import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ReturnsStatus, User } from '@app/core/models';
import { select, State, Store } from '@ngrx/store';
import { AppState, selectProfile, ReturnsStatusActionTypes } from '@app/core/ngrx';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

/**
 * FrameReturnsStatusComponent
 */
@Component({
  selector: 'ecp-returns-status',
  templateUrl: './frame-returns-status.component.html',
  styleUrls: ['./frame-returns-status.component.scss'],
})
export class FrameReturnsStatusComponent implements OnInit, AfterViewInit {
  @ViewChild('stickyMenu') menuElement: ElementRef;
  user$: Observable<User>;
  frameReturns$: Observable<ReturnsStatus[]>;
  loading$: Observable<boolean>;
  public searchTerm$: Observable<string>;
  public searchTerm = '';

  constructor(private store: Store<AppState>, private router: Router, private state: State<AppState>) {}

  ngOnInit() {
    this.user$ = this.store.pipe(select(selectProfile));
    this.loading$ = this.store.pipe(select(state => state.returnsStatus.pending));
    // we need to get the VisionWeb token from the user's profile
    this.user$.subscribe(user => {
      // once we have the token we can call the other services
      if (user.token) {
        window.localStorage.setItem('token', user.token);
        this.store.dispatch({
          type: ReturnsStatusActionTypes.LOAD_RETURNS_STATUS,
        });
      }
    });
    this.frameReturns$ = this.store.pipe(select(state => state.returnsStatus.frameReturns));

    this.searchTerm$ = this.store.pipe(select(state => state.returnsStatus.searchTerm));

    this.frameReturns$.pipe().subscribe();

    //sort by requestedDate in descending order
    this.frameReturns$ = this.frameReturns$.pipe(
      map(data => {
        let arrayForSort = [...data];
        return arrayForSort.sort((x, y) => +new Date(y.requestedDate) - +new Date(x.requestedDate));
      }),
    );

    this.searchTerm$.subscribe(searchTerm => {
      this.searchTerm = searchTerm;
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}
